import {useQuery, UseQueryOptions} from '@tanstack/react-query';
import {createModel, Model} from '@/engine';
import {Configuration} from '@/model/types';

export const useModelQuery = (config: Configuration, options: Partial<UseQueryOptions<Model, Error, Model>> = {}) => {
  const {enabled = true} = options;

  return useQuery({
    queryKey: ['model', config.version],
    queryFn: () => createModel(config),
    enabled: !!enabled,
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};
